import React from 'react';
import {I18nUtils} from "../../../../i18n/I18nUtils";
import DocumentsTab from "../../../shared/components/tabs/documents/DocumentsTab";
import StateManager from "../../../shared/utils/StateManager";
import DocumentSchemaType from "../../../shared/model/DocumentSchemaType";
import PropTypes from "prop-types";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import * as exportOutsourceDocsActions from "../../actions/exportOutsourceDocsActions";

class ExportOutsourceDocsCardTabOutsource extends React.Component {

  static TAB_ID = 'outsource';

  static renderTabHeader() {
    return (
      <li role="presentation" className="active">
        <a href={'#' + this.TAB_ID} data-toggle="tab" aria-expanded="true">{I18nUtils.tr('TR_SUBCONTRATA').toUpperCase()}</a>
      </li>
    );
  }

  render() {
    return (
      <div role="tabpanel" className="tab-pane fade active in" id={ExportOutsourceDocsCardTabOutsource.TAB_ID}>
        <DocumentsTab
          id={StateManager.EXP_DOC_TAB_OUTSOURCE}
          title={I18nUtils.tr('TR_DOCUMENTOS_SUBCONTRATAS')}
          documentSchemaType={DocumentSchemaType.OUTSOURCE}
          companyId={this.props.companyId}
          selectedIds={this.props.selectedIds}
          actionSelectItem={this.props.exportOutsourceDocsActions.checkOutsourceDocument}
          actionSelectAll={this.props.exportOutsourceDocsActions.checkOutsourceDocuments}
        />
      </div>
    );
  }

}

const mapStateToProps = (state, ownProps) => {
  const documentIds = state.exportOutsourceDocs.outsourceDocuments.map(document => document.id);
  return {
    selectedIds: documentIds,
  }
};

const mapDispatchToProps = dispatch => ({
  exportOutsourceDocsActions: bindActionCreators(exportOutsourceDocsActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(ExportOutsourceDocsCardTabOutsource)

ExportOutsourceDocsCardTabOutsource.propTypes = {
  companyId: PropTypes.string.isRequired,
};

ExportOutsourceDocsCardTabOutsource.defaultProps = {
};



// WEBPACK FOOTER //
// ./src/app/outsource/components/export/ExportOutsourceDocsCardTabOutsource.js